import React from 'react'
import styled from 'styled-components'
import theme from './theme.js'

const IconInline = ({
  className,
  type
}) => {
  const props = {
    className
  }

  const icons = {
    page: import('./icon-inline-page.js').then(module => module.default),
    shop: import('./icon-inline-shop.js').then(module => module.default),
    video: import('./icon-inline-video.js').then(module => module.default)
  }

  const Icon = icons[type] || icons.page

  return <Icon {...props} />
}

export const Icon = styled.div`
  width: 1.9em;
  height: 2.4em;
  opacity: .5;
  border: 2px solid ${theme.color.grey.darkest};
  border-width: 0 0 2px 2px;
  opacity: .5;
`

export default IconInline
